module.exports = __webpack_public_path__ + "img/spiral-details9.faa91e83.png";